module.exports = __webpack_public_path__ + "static/media/icon-present.37fff190.svg";